/**
 * Disables every form control and button inside it, like HTML's
 * `<fieldset disabled>`.
 *
 * Lets a screen built from feature-supplied widgets show its controls to a user
 * who can view it but not change it, without threading a `disabled` prop
 * through each widget. Controls read it through `useFormDisabled`.
 */

import React, { createContext, useContext } from 'react';

const FormDisabledContext = createContext(false);

export function FormDisabled({ disabled, children }: { disabled: boolean; children: React.ReactNode }) {
    const outerDisabled = useContext(FormDisabledContext);
    return <FormDisabledContext.Provider value={outerDisabled || disabled}>{children}</FormDisabledContext.Provider>;
}

export function useFormDisabled(): boolean {
    return useContext(FormDisabledContext);
}
